import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=67fd7753&scoped=true&"
import script from "./POI.vue?vue&type=script&lang=js&"
export * from "./POI.vue?vue&type=script&lang=js&"
import style0 from "./POI.vue?vue&type=style&index=0&id=67fd7753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd7753",
  null
  
)

export default component.exports